// ✅ Production-ready: No console logging - defined once at module level
const isDevelopment = process.env.NODE_ENV === "development";

/**
 * Check if the current window is inside an iframe
 * @returns {boolean} True if the window is inside an iframe
 */
export const isInIframe = () => {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
};

// Get URL parameter
export const getUrlParameter = (name) => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(name);
};

// Get sidebar parameter
export const getSidebarParam = () => {
  try {
    const url = window.location.href;
    // Match any page with structure: /:page/:param1?/:sidebar?/:hidediv?
    // This regex captures the sidebar parameter (second optional parameter)
    const sidebarMatch = url.match(/\/[^\/]+\/[^\/]*\/([^\/\?#]*)/);

    if (sidebarMatch && sidebarMatch[1]) {
      // Sanitize the sidebar parameter to prevent XSS
      const sidebar = sidebarMatch[1].replace(/[<>\"'&]/g, "");
      // Return true if sidebar is set (meaning it should be hidden), false otherwise
      return sidebar && sidebar.length > 0;
    }

    // No sidebar parameter found, return false (don't hide sidebar)
    return false;
  } catch (error) {
    if (!isDevelopment && window.errorReporting) {
      window.errorReporting.captureException(error);
    }
    // On error, default to false (don't hide sidebar)
    return false;
  }
};

// Get storage value
export const getStorageValue = (key) => {
  try {
    const value = localStorage.getItem(key);
    return value ? JSON.parse(value) : null;
  } catch (error) {
    if (!isDevelopment && window.errorReporting) {
      window.errorReporting.captureException(error);
    }
    return null;
  }
};

// Open URL in new tab
export const openURLInNewTab = (url) => {
  if (!url) return;
  window.open(url, "_blank", "noopener,noreferrer");
};

// Get date in YYYY-MM-DD format
export const getDate = (date) => {
  if (!date) {
    if (!isDevelopment && window.errorReporting) {
      window.errorReporting.captureException(
        new Error("Invalid date provided to getDate")
      );
    }
    return null;
  }

  try {
    return new Date(date).toLocaleDateString();
  } catch (error) {
    if (!isDevelopment && window.errorReporting) {
      window.errorReporting.captureException(error);
    }
    return null;
  }
};
